import type { MenuProduct } from "@/types";
import { formatSAR } from "@/utils/format";

interface PosProductCardProps {
  product: MenuProduct;
  quantity: number;
  onAdd: (product: MenuProduct) => void;
}

export default function PosProductCard({
  product,
  quantity,
  onAdd,
}: PosProductCardProps) {
  const disabled = !product.isAvailable || product.stock <= 0;

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onAdd(product)}
      className={`group yc-card-hover relative text-right rounded-card border bg-white overflow-hidden ${
        disabled
          ? "border-background-200 opacity-60 cursor-not-allowed"
          : "border-background-200 hover:border-primary-300 cursor-pointer"
      }`}
    >
      <div className="relative w-full h-28 bg-background-100">
        <img
          src={product.image}
          alt={product.name}
          title={`${product.name} — نقطة البيع`}
          className="w-full h-full object-cover object-top"
        />
        {quantity > 0 && (
          <span className="absolute top-2 start-2 min-w-[24px] h-6 px-1.5 inline-flex items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-white">
            {quantity}
          </span>
        )}
        {disabled && (
          <span className="absolute top-2 end-2 rounded-full bg-red-500 px-2 py-0.5 text-[11px] font-semibold text-white">
            غير متوفر
          </span>
        )}
      </div>

      <div className="p-3">
        <h3 className="text-sm font-bold text-foreground-950 line-clamp-1">
          {product.name}
        </h3>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-sm font-bold text-primary-700">
            {formatSAR(product.price)}
          </span>
          <span
            className={`w-7 h-7 flex items-center justify-center rounded-full text-lg transition-colors duration-200 ${
              disabled
                ? "bg-background-100 text-foreground-300"
                : "bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-white"
            }`}
          >
            <i className="ri-add-line"></i>
          </span>
        </div>
      </div>
    </button>
  );
}